export const SITE_ORIGIN = "https://forteana.earthboundmartian.com";
export const SITE_NAME = "Forteana";
export const SITE_TAGLINE = "Ghost hunts, cryptids, overnight strangeness.";
export const SITE_DESCRIPTION =
  "A free map of ghost hunts, haunted stays, cryptid gatherings, Bigfoot festivals, and UFO weekends — with dates, camping notes, and trip planning.";
export const ORG_ORIGIN = "https://earthboundmartian.com";
export const ORG_NAME = "Earthbound Martian, LLC";
export const CONTACT_EMAIL = "forteana@earthboundmartian.com";
